import { render, staticRenderFns } from "./AsideBarWorkItems.vue?vue&type=template&id=1c5e52e6&scoped=true&"
import script from "./AsideBarWorkItems.vue?vue&type=script&lang=js&"
export * from "./AsideBarWorkItems.vue?vue&type=script&lang=js&"
import style0 from "./AsideBarWorkItems.vue?vue&type=style&index=0&id=1c5e52e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e52e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VContainer,VIcon,VListItemContent,VListItemSubtitle,VListItemTitle})
